window.Adyen = {
	
	loadPrefs : function(){
		var options = {
			title	: Loc.g("Préférences Adyen"),
			buttons	: [
                {	text : Loc.g("Fermer"),
                    class: 'btn btn-default',
						click :function(){
							MyWindow.close();
						}
                },
                {
                    text : Loc.g("Enregistrer"),
                    class: 'btn btn-primary',
					click : function(){
                		$('#adyenForm').submit()
                	}
                }
			],
			callback	: function(){Adyen.preparePrefsForm();Qtip.init();},
			width: 680
		};

		var fileOpt = {action:"connection"};
		MyWindow.load("adyen_prefs", fileOpt, options);
		
	},

	loadPrefsPayByLink: function ()
	{
		window.sellsyapp.$store.state.popupPanel.adyenPopup.props = { }
		window.sellsyapp.$store.state.popupPanel.adyenPopup.display = true
	},
	
	preparePrefsForm : function(){
		var formId = "adyenForm";
		var options = {
			success:function(data){Adyen.recordCallback(data);}, 
			dataType:"json"
		};
		MyForm.prepare(formId, "adyen_prefs&action=record", options, true);
		MyFacture.initEvent("#"+formId);
	},
	
	recordCallback : function(data){
		var formIsOk = MyForm.processJson(data, "adyenForm", "popupWindow");
		if (formIsOk){
			Utils.reload();
		}
	},
	
};